import {
  makeStyles,
  TableCell as MuiTableCell,
  TableCellProps,
} from "@material-ui/core"
import clsx from "clsx"
import React, { FC } from "react"
import { colors } from "../../utils/theme"

const useStyles = makeStyles({
  tableCell: {
    color: colors.neutral.denim,
    fontWeight: 400,
    borderBottom: `1px solid ${colors.neutral.clay}`,
    cursor: "pointer",
    paddingTop: 0,
    paddingBottom: 0,
  },
  borderLeft: {
    borderLeft: `1px solid ${colors.neutral.clay}`,
  },
})

interface ViraTableCellProps extends TableCellProps {
  borderLeft?: boolean
}

const TableCell: FC<ViraTableCellProps> = (props) => {
  const classes = useStyles()
  const classNames = [classes.tableCell, props.className]
  if (props.borderLeft) {
    classNames.push(classes.borderLeft)
  }
  return <MuiTableCell {...props} className={clsx(classNames)} />
}

export default TableCell
